import { render } from "./SessionExpiry.vue?vue&type=template&id=89ca1236"
import script from "./SessionExpiry.vue?vue&type=script&lang=js"
export * from "./SessionExpiry.vue?vue&type=script&lang=js"

import "./SessionExpiry.vue?vue&type=style&index=0&id=89ca1236&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__